function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #e3f5fe !important;\n      }\n\n      .cls-1 {\n        opacity: 0.3;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        filter: url(#filter);\n      }\n\n      .cls-4 {\n        font-size: 16px;\n        fill: #083d77 !important;\n        text-anchor: middle;\n        font-family: Montserrat;\n        font-weight: 400;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 0,
  y: 0,
  width: 84,
  height: 84,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  result: "offset",
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 4.583
}), /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodOpacity: 0.18
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_2",
  "data-name": "Elipsa 1 kopia 2",
  className: "cls-1",
  cx: 83.25,
  cy: 88.125,
  r: 76.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_3",
  "data-name": "Elipsa 1 kopia 3",
  className: "cls-2",
  cx: 83.25,
  cy: 88.125,
  r: 55.844
});

var _ref5 = /*#__PURE__*/React.createElement("image", {
  id: "presentation-card-in-open-envelope",
  x: 59,
  y: 58,
  width: 52,
  height: 56,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA4CAYAAACyutuQAAAFRklEQVRoge2aeWhcVRTGf03aasY0bdW4olittC6o1VDcuqh1LYp7KPqHaBERcUcRERUEN7TaImjdioJVsS61aqO4NwZF4hYSrUswghpwbWyrTdPIke/K9fXNzH3LTEboB8PMfXO37917z3fOeW/U1jOupULYDbgQmKXfm4A+4A3gQeDHSgxbKUJXALcBY4v8vx64FHgo74FH59xfPXA/MN+79h3wIVAHTAd2Bhq0SvsAVwPDeU2gLq+OgALwgkdmvX7vAZwOnArsrpUZVJ0rgaUlVjIx8iLUDLwJzFX5J+Ao4GGdHYeNwCLgRGCNrrUCbcD4WiJ0q7aT4RvgcOD9EvVfB2YC36s8G7ghj4nkRegzfRuJw4AvA9p8orpdkT4yIU8rtx3wa2SLhcAM0wRt08woZuWmy/Q25MU2Z6zVNu+KdluM0N3AETVKxqEJODl6sRihRn0Pe9aoVuCs4bi4+ZQT1j7pSC3ht1ImPk9hrQlsIVTr2EKo1pF3+GDB3LnAmMD6f8mB/SCvCThCo4ADgS/k9qfFo8CkhG1bgEMyjGmauSfwKdpyFse8CHwEvJqhY8NzChFCsQF4PuOYHXJ0n7S4ylZoJTBDf26bsfOr9Kkm3JwtrirUeWSQC19f5QllwVi31YSZUaPQqi2Y1ss+CJgHbBVY387rY0BPirGaFOnO9i/GWbnNPNgEeBrYO2EbC9UPTTHWtLiLvg69A/SmYeHh3RRtVmUcs8c3+z6hXoXEnd615oQm9QJthYmBn0alsUJheYhtvLqrFLf9EEfI0C9xbFPZztPbwAkJBh2Qix/yWZug37OA17xjsgw4VmH/v4hzff7QOVqist2RFcD5CQbPG5cDT3n5u4UyYH9Gxynmyw2KwC0q18tFubHKRMyDuQtYoN+Ga4DLgKG4BqWc02Hlyi7yMjk3KYVbDa2y1Viq7Cq6yecAd5ZqFOJtPwCc5vl485XyLWSfc1GM1zluVYU1yrY+Ua5hqLe9HDhG39sr5WvG4qX8ufyDM4D99duyqyfJXyuLJOFDh0zkSnnULfpUEj2ysH2hYyQN8FbHaFWl4DQmmAwpAzynVc8Ax+uaGY1LgFdSkjONucMrL1OguJlZLoe0EavTqsXAeVrpRXoE+UjCvkxjbvfKC2XZYs1yOWTJKWTVqsQaU2lCRLTKIUSrohozFKIxIcgj62MTPzhyzWlVY0z9iRGNcX1M81YqNbJmfQqK5V0MZeK7Ts+K5ioCvlcm327ekTozu6h+v0LoMfK6d9WZ3DAShJoltC44swdWpwA/S3AnK9G/oEj7LpGeIovZpGh3Rz1k/j3NpNJuOUsbtXtkeiW6HdIq24L3aLWiGPCeyfYpJJjlxTRHK9i01UqMNCtkAd/LwA4qd8o16ffqDOgJ4PUiOkkG5CuRjurLxxJs80KmAgeonnkJ3Ukml5TQccq9OcfUDveZ0qU4rNMKhOBbkV+ub3udpl3bODi0T7rlFntklsgYFCOTBr8oCn1WbSfoBgYjKaEV2i43S1QHA9okhVnKs+UxEPdguBTKETJ9uE6Wapz8tQaJZ27v58RgSB7DTsAczfNi3cSSWlXqDBWUZ3Ovu3TLA6gmnKGxrX2ffs8ppVXFViju3Z23qkzGR7f3NH6evPrYB8dxhPYC3vPe3XEaE/K6S6XwdahWRQm1yP5PVrlT+rB6BMk4OK36XGWnVfv6lXxCLcoTNKvcprvST+3AaVW7ZuS0amocof0qrDF5IU6rpri+46zcRvlqoQo/UqiXdPzHjMcRGq2k+P8SNnkTTUskZg6uRhibgMf/BrEnF5QZ5GqsAAAAAElFTkSuQmCC"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_3",
  "data-name": "Elipsa 3",
  className: "cls-3",
  cx: 41.25,
  cy: 41.295,
  r: 21.25
});

var _ref7 = /*#__PURE__*/React.createElement("text", {
  id: "_2",
  "data-name": 2,
  className: "cls-4",
  x: 40.999,
  y: 46.501
}, "2");

var SvgKrok2 = function SvgKrok2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupa_12",
    "data-name": "Grupa 12",
    width: 159.75,
    height: 164.78,
    viewBox: "0 0 159.75 164.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKrok2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/krok2.df315619.svg";
export { ForwardRef as ReactComponent };